<template>
  <section class="network-widget" :style="{'--invoker-bgColor': this.$store.state.template.header.bgColor, '--invoker-textColor': this.$store.state.template.header.menuColor}">
    <transition appear name="fade">
    <div class="network-widget-coverplate" v-show="notCached">
      
      <div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      
      <h2 class="neon">Olá, {{$store.state.user.name}}!</h2>
      
      <h3 class="neon">Estamos preparando um mundo novo para você que estará pronto em alguns segundos...</h3>
    </div>
    </transition>

    <!-- <transition appear name="translate-left">
    <i class="fas fa-users network-widget-top-right-invoker" @click.prevent="showUsersList=!showUsersList" v-if="!showUsersList"></i>
    </transition> -->
    <div class="network-widget-close-btn" @click.prevent="closeList" v-if="showUsersList"></div>

    <transition appear :name="computedEnterAnimationName">
    <div ref="userListScroller" class="network-widget-user-list-container" v-show="showUsersList">
      <div class="network-widget-search-container">
        <input class="network-widget-search-input" type="text" v-model="userSearch" placeholder="Procurar..." @keydown.enter="searchAPI">
        <i class="fa fa-times-circle clearSearch" @click.prevent="apiGetUsers"></i>
        <i class="fas fa-search" @click.prevent="searchAPI"></i>
        <!-- <i class="far fa-window-close closeWindow"></i> -->
      </div>
      <!-- <input type="text" class="network-widget-search-input" v-model="userSearch"> -->
      <div class="network-widget-user-container" v-for="user in usersComputed" :key="user.user_id">
        <div class="user-main-view">
          <img :title="user.name" :src="user.image">
          <div class="network-widget-user-texts">
            <p class="user-name">{{user.name}}</p>
            <p class="user-role">{{user.role}}</p>
          </div>
        </div>
        <div class="user-tools-view">
          <i class="fas fa-envelope" title="Mensagem" @click.stop="openChannel(user.target)"></i>
          <i class="fas fa-video" title="Vídeo Chamada" @click.stop="openBlitzarMeeting(user.target)"></i>
          <i class="fas fa-user-plus" style="opacity:0.2" @click.prevent=""></i>
          <i class="fas fa-calendar-alt" style="opacity:0.2" @click.prevent=""></i>
        </div>
      </div>
    </div>
    </transition>

    <VueDragResize class="meeting-container__wrapper" :x="webRTC_x" :y="webRTC_y" :w="webRTCWidth" :h="webRTCHeight" :parentLimitation="true" :preventActiveBehavior="false" :isResizable="false" @dragging="dragHandler" @resizing="resizeHandler" v-if="roomId">
    <div class="meeting-container" :style="{right:`${meetingContainerComputedRight}px`,bottom:`${meetingContainerComputedBottom}px`}" v-if="roomId">
      <div class="meeting-container-views-btns dragHandle">
        <!-- <i class="fas fa-grip-lines" style="flex-grow:1"></i> -->
        <i class="fas fa-minus" @click.prevent="decreaseCameraHeight" v-if="cameraHeight>10"></i>
        <i class="fas fa-plus" @click.prevent="increaseCameraHeight"></i>
      </div>   
    <WebRTC ref="webrtc" width="100%" :roomId="roomId" :cameraHeight="cameraHeight" :userImage="$store.state.user.picture ?$store.state.user.picture:''" :userName="$store.state.user.name ?$store.state.user.name:''" :isVerticalOrientation="isVerticalOrientation" @joined-room="joinedRoom" @left-room="logEvent" @opened-room="logEvent" @share-started="logEvent" @share-stopped="logEvent" @error="onError" />
      <div class="meeting-container-tools-btns dragHandle">
        <i :class="{'fas fa-grip-vertical':isVerticalOrientation,'fas fa-grip-horizontal':!isVerticalOrientation}" style="min-width:16px" @click.prevent="toggleOrientation"></i>
        <i class="" :class="{'fas fa-microphone':!isLocalStreamMuted,'fas fa-microphone-slash':isLocalStreamMuted}" @click.prevent="toggleLocalStreamAudioTrack"></i>
        <i class="" :class="{'fas fa-video':!isLocalStreamDisabled,'fas fa-video-slash':isLocalStreamDisabled}" @click.prevent="toggleLocalStreamVideoTrack"></i>
        <!-- <i class="fas fa-user-plus" style="opacity:0.3" @click.prevent=""></i> -->
        <i class="fas fa-sign-out-alt" style="font-size:1.2rem;color:#d55" @click.prevent="closeMeeting"></i>
      </div>
    </div>
    </VueDragResize>
    <div class="network-widget-invoker-btn" @click.prevent="openUsersList">
      <i class="fas fa-users"></i>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';
import DefaultAvatar from '@/assets/img/default_avatar.png';
import WebRTC from '@/components/webrtc/WebRTC.vue';
import VueDragResize from 'vue-drag-resize';

export default {
  name: 'NetworkWidget',
  components: {
    WebRTC,
    VueDragResize,
  },

  data() {
    return {
      showUsersList: false,
      users: [],
      itensPerPage: 25,
      paginationCount: 0,
      userSearch: '',
      searchAPITerm: '',
      currentUser: null,
      channelId: '',
      showIframe: false,
      roomId: '',
      isVerticalOrientation: true,
      isLocalStreamDisabled: false,
      isLocalStreamMuted: false,
      webRTCWidth: 264,
      webRTCHeight: 242,
      webRTC_x: 0,
      webRTC_y: 0,
      mcAbsoluteRight: 20,
      mcAbsoluteBottom: 34,
      cameraHeight: 180,
      notCached: false,
    };
  },
  computed: {
    usersComputed() {
      return this.users;
      return this.users.filter(user => user.name.toLowerCase().match(this.userSearch.toLowerCase()));
    },
    meetingContainerComputedRight() {
      return window.innerWidth - (this.webRTC_x + this.webRTCWidth + 24);
    },
    meetingContainerComputedBottom() {
      return window.innerHeight - (this.webRTC_y + this.webRTCHeight + 26);
    },
    computedEnterAnimationName() {
      return window.innerWidth > 486 ? 'translate-left' : 'translate-up';
    },
  },
  methods: {
    apiGetUsers() {
      this.userSearch = '';
      return new Promise((resolve, reject) => {
        api
          .get(`event/${this.$store.state.eventId}/userSearch?limit=${this.itensPerPage}&page=${this.paginationCount}`)
          .then(response => {
            if (response.data) {
              let users = [];
              response.data.userExists.map(item => {
                users.push({
                  image: item.image ? item.image : DefaultAvatar,
                  name: item.name ? item.name : item.email,
                  role: `${item.role ?? ''} ${item.role && item.company ? ' - ' : ''} ${item.company ?? ''} ${(item.role || item.company) && item.city ? ' - ' : ''} ${item.city ? item.city : ''} ${item.state ? ' - ' + item.state : ''} ${item.about_me ? ' - ' + item.about_me : ''}`,
                  other: item.other ?? '',
                  action: 'MENSAGEM',
                  actionType: 'talk',
                  enableAction: true,
                  url: item.user_id > this.$store.state.user.id ? item.user_id + this.$store.state.user.id : this.$store.state.user.id + item.user_id,
                  target: item.user_id,
                  enableAction: item.user_id != this.$store.state.user.id,
                  public_events: item.public_events ? parseInt(item.public_events) : 0,
                });
              });
              this.users = [...users];
              resolve();
            }
          })
          .catch(err => console.error(err));
      });
    },
    apiGetUsersOnScroll() {
      if (Math.abs(this.$refs.userListScroller.offsetHeight + this.$refs.userListScroller.scrollTop) >= this.$refs.userListScroller.scrollHeight) {
        this.paginationCount++;
        api
          .get(`event/${this.$store.state.eventId}/userSearch?limit=${this.itensPerPage}&page=${this.paginationCount * this.itensPerPage}`)
          .then(response => {
            if (response.data) {
              let users = [];
              response.data.userExists.map(item => {
                users.push({
                  image: item.image ? item.image : DefaultAvatar,
                  name: item.name ? item.name : item.email,
                  role: `${item.role ?? ''} ${item.role && item.company ? ' - ' : ''} ${item.company ?? ''} ${(item.role || item.company) && item.city ? ' - ' : ''} ${item.city ? item.city : ''} ${item.state ? ' - ' + item.state : ''} ${item.about_me ? ' - ' + item.about_me : ''}`,
                  other: item.other ?? '',
                  action: 'MENSAGEM',
                  actionType: 'talk',
                  enableAction: true,
                  url: item.user_id > this.$store.state.user.id ? item.user_id + this.$store.state.user.id : this.$store.state.user.id + item.user_id,
                  target: item.user_id,
                  enableAction: item.user_id != this.$store.state.user.id,
                  public_events: item.public_events ? parseInt(item.public_events) : 0,
                });
              });
              this.users = [...this.users, ...users];
            }
          })
          .catch(err => console.error(err));
      }
    },
    userSearchQuery() {
      this.searchAPITerm = this.userSearch;
      // let mainURL = `/userSearch?field[]=code&field[]=name&value=SP&limit=500&page=0&order_by=name&asc_desc=asc`;
      let orderingField = `&asc_desc=asc`;
      let nameField = `&field[]=name`;
      let companyField = `&field[]=company`;
      let cityField = `&field[]=city`;
      let stateField = `&field[]=state`;
      let valueField = this.searchAPITerm ? `&value=${this.searchAPITerm}` : '';
      return `${nameField}${companyField}${orderingField}${valueField}`;
    },
    searchAPI() {
      this.showSpinner = true;
      api
        .get(`event/${this.$store.state.eventId}/userSearch?limit=${this.itensPerPage}&page=0${this.userSearchQuery()}`)
        .then(response => {
          this.showSpinner = false;
          if (response.data) {
            this.paginationCount = 0;
            let users = [];
            response.data.userExists.map(item => {
              users.push({
                image: item.image ? item.image : DefaultAvatar,
                name: item.name ? item.name : item.email,
                role: `${item.role ?? ''} ${item.role && item.company ? ' - ' : ''} ${item.company ?? ''} ${(item.role || item.company) && item.city ? ' - ' : ''} ${item.city ? item.city : ''} ${item.state ? ' - ' + item.state : ''} ${item.about_me ? ' - ' + item.about_me : ''}`,
                action: 'MENSAGEM',
                actionType: 'talk',
                enableAction: true,
                url: item.user_id > this.$store.state.user.id ? item.user_id + this.$store.state.user.id : this.$store.state.user.id + item.user_id,
                target: item.user_id,
                enableAction: item.user_id != this.$store.state.user.id,
                public_events: item.public_events ? parseInt(item.public_events) : 0,
              });
            });
            this.users = [...users];
          }
        })
        .catch(err => console.error(err));
    },
    async openUsersList() {
      if (!this.showUsersList) {
        await this.apiGetUsers();
        this.showUsersList = !this.showUsersList;
      } else this.showUsersList = !this.showUsersList;
    },
    avatarClicked(user) {
      this.currentUser = user;
    },
    openChannel(user_id) {
      api
        .post(`event/${this.$store.state.eventId}/createTalkChannel`, { user_id: user_id, channelName: user_id > this.$store.state.user.id ? user_id + this.$store.state.user.id : this.$store.state.user.id + user_id })
        .then(async response => {
          if (response.data) {
            this.channelId = response.data.talk_channel_id;
            this.$root.$emit('openChannel', this.channelId);
            this.showUsersList = false;
          }
        })
        .catch(err => console.error(err));
    },
    openBlitzarMeeting(user_id) {
      this.$nextTick(() => {
        api
          .post(`event/${this.$store.state.eventId}/createTalkChannel`, { user_id: user_id, channelName: user_id > this.$store.state.user.id ? user_id + this.$store.state.user.id : this.$store.state.user.id + user_id })
          .then(async response => {
            if (response.data) {
              this.channelId = response.data.talk_channel_id;
              const invite = await this.sendInviteMessage(this.channelId);
              this.roomId = this.channelId;
              this.$nextTick(() => this.webRTCJoin());
              document.getElementById('messagesContainer').focus();
              this.$root.$emit('openChannel', this.channelId);
              this.showUsersList = false;
              this.webRTC_x = window.innerWidth - this.webRTCWidth - this.mcAbsoluteRight;
              this.webRTC_y = window.innerHeight - this.webRTCHeight - this.mcAbsoluteBottom;
            }
          })
          .catch(err => console.error(err));
      });
    },
    sendInviteMessage(channelID) {
      return new Promise((resolve, reject) => {
        api
          .post(`event/${this.$store.state.eventId}/sendMessageChannel`, {
            channel_id: channelID,
            message: `${this.$store.state.user.name} está te convidando para uma vídeo chamada. Clique para entrar.`,
            reactions: 'blitzar-meeting-invite',
          })
          .then(response => {
            resolve(response);
          })
          .catch(err => console.error(err));
      });
    },
    postMessageToIframe(message) {
      this.$nextTick(() => {
        this.$refs.iframe.contentWindow.postMessage(
          {
            sender: 'meeting',
            user: this.$store.state.user.name,
            language: 'pt-PT',
            msg: message,
          },
          '*',
        );
      });
    },
    closeList() {
      this.showUsersList = false;
    },
    closeUser() {
      this.currentUser = null;
    },
    closeMeeting() {
      this.roomId = '';
      this.isLocalStreamDisabled = false;
      this.isLocalStreamMuted = false;
      this.webRTCLeave();
      this.$root.$emit('leaveBlitzarMeeting', 'public_room');
    },
    webRTCJoin() {
      this.$refs.webrtc.join();
    },
    joinedRoom(streamId, videoCount) {
      // console.log('joinedRoom with # of users', videoCount);
    },
    webRTCLeave() {
      this.$refs.webrtc.leave();
    },
    dragHandler(event) {
      this.webRTC_x = event.left;
      this.webRTC_y = event.top;
      // this.webRTC_x = Math.abs(Math.ceil(window.innerWidth - 300));
      // this.webRTC_y = Math.abs(Math.ceil(window.innerHeight - 200));
    },
    resizeHandler(event) {
      // this.webRTC_x = event.left;
      // this.webRTC_y = event.top;
      this.webRTCWidth = event.width;
      this.webRTCHeight = event.height;
    },
    increaseCameraHeight() {
      this.webRTCHeight = this.webRTCHeight + 10;
      this.webRTCWidth = this.webRTCWidth + 10;
      this.cameraHeight = this.cameraHeight + 10;
    },
    decreaseCameraHeight() {
      this.webRTCHeight = this.webRTCHeight - 10;
      this.webRTCWidth = this.webRTCWidth - 10;
      this.cameraHeight = this.cameraHeight - 10;
    },
    toggleOrientation() {
      this.isVerticalOrientation = !this.isVerticalOrientation;
    },
    toggleLocalStreamAudioTrack() {
      this.$refs.webrtc.toggleLocalStreamAudioTrack(this.isLocalStreamMuted);
      this.isLocalStreamMuted = !this.isLocalStreamMuted;
    },
    toggleLocalStreamVideoTrack() {
      this.$refs.webrtc.toggleLocalStreamVideoTrack(this.isLocalStreamDisabled);
      this.isLocalStreamDisabled = !this.isLocalStreamDisabled;
    },
    onError(error, stream) {
      console.error('On Error Event', error, stream);
    },
    logEvent(event) {
      // console.log('Event : ', event);
    },
  },

  beforeMount() {
    this.apiGetUsers();
  },
  mounted() {
    this.$store.commit('setUserInMeeting', false);
    this.$root.$on('openNetworkWidget', _ => {
      this.showUsersList = !this.showUsersList;
    });
    this.$root.$on('joinBlitzarMeeting', data => {
      this.webRTC_x = window.innerWidth - this.webRTCWidth - this.mcAbsoluteRight;
      this.webRTC_y = window.innerHeight - this.webRTCHeight - this.mcAbsoluteBottom;
      this.roomId = data;
      this.$nextTick(() => this.webRTCJoin());
    });
    this.$refs.userListScroller.addEventListener('scroll', this.apiGetUsersOnScroll);

    this.$root.$on('startCaching', data => {
      this.notCached = true;
    });
    this.$root.$on('routesCached', data => {
      this.notCached = false;
    });
  },
  beforeDestroy() {
    this.$refs.userListScroller.removeEventListener('scroll', this.apiGetUsersOnScroll);
  },
};
</script>

<style lang="scss" scoped>
.network-widget {
  pointer-events: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  // z-index: 2000;
  z-index: 1;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;
}
.network-widget-top-right-invoker {
  pointer-events: auto;
  position: fixed;
  right: 10px;
  top: 94px;
  @include media("<=phone") {
    top: 50px;
  }
  font-size: 2rem;
  margin-top: 8px;
  padding: 8px;
  border-radius: 8px;
  background: #4444;
  // box-shadow: 0px 0px 8px #444;

  &:active {
    transform: scale(0.9);
  }
}
.network-widget-close-btn {
  pointer-events: auto;
  position: relative;
  // background: #4449;
  width: 80%;
  height: 100%;
  z-index: 1;
  @include media("<=phone") {
    width: 0;
  }
}
.network-widget-user-list-container {
  pointer-events: auto;
  user-select: none;
  position: relative;
  width: 320px;
  height: 100%;
  margin: 60px 0 32px;
  padding-bottom: 200px;
  overflow-y: auto;
  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: blur(20px) brightness(0.4);
    backdrop-filter: blur(20px) brightness(0.4);
  }
  @include media("<=phone-plus") {
    margin: 50px 0 32px;
    width: 100%;
  }
  display: flex;
  flex-wrap: wrap;
  // align-items: flex-start;
  align-content: flex-start;
  // justify-content: center;
}
.network-widget-search-container {
  position: absolute;
  padding: 0px 4px 0px 6px;
  width: 100%;
  color: #aaa;
  background: #8884;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .clearSearch {
    margin-right: 10px;
    font-size: 0.9rem;
    opacity: 0.5;
  }
  .network-widget-search-input {
    flex-grow: 1;
    height: 40px;
    margin-right: 10px;
    padding: 0 4px;
    font-size: 1.1rem;
    color: white;
    background: transparent;
    border: none;

    &::placeholder {
      color: #ddd8;
    }
  }

  .closeWindow {
    margin-left: 60px;
    font-size: 1.8rem;
    // background: red;
  }
}
.network-widget-user-container {
  position: relative;
  padding: 8px 12px;
  width: 100%;
  min-width: 100px;
  color: white;
  // box-shadow: -2px 2px 8px 0px #444;

  display: flex;
  flex-wrap: wrap;
  align-items: center;

  &:hover {
    background: #222;
  }
  &:nth-child(2) {
    margin-top: 50px;
  }
}
.network-widget-user-container:hover > .user-tools-view {
  display: flex;
}
.user-main-view {
  position: relative;
  display: flex;
  img {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
  }
  .network-widget-user-texts {
    .user-name {
      font-size: 1.03rem;
      opacity: 0.9;
    }
    .user-role {
      font-size: 0.9rem;
      opacity: 0.55;
    }
  }
}
.user-tools-view {
  width: 100%;
  margin: 10px 0 0 0;

  display: none;
  justify-content: space-evenly;
  i {
    margin-right: 10px;
    opacity: 0.7;
  }
}
.network-widget-invoker-btn {
  pointer-events: auto;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 8px 0;
  background: var(--invoker-bgColor);
  // background: transparent;

  display: none;
  @include media("<=phone") {
    display: flex;
  }
  justify-content: center;

  i {
    font-size: 1.5rem;
    color: var(--invoker-textColor);
  }
}
.meeting-container__wrapper {
  z-index: 10000 !important;
}
.meeting-container__wrapper .active {
  border: none !important;
  z-index: 1000;
}
.meeting-container {
  cursor: grab;
  pointer-events: auto;
  position: fixed;
  right: 20px;
  bottom: 34px;
  min-width: 264px;
  margin: 0 24px 32px 0px;
  padding: 4px 4px 0 4px;
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: blur(20px) brightness(0.4);
    backdrop-filter: blur(20px) brightness(0.4);
  }
  iframe {
    pointer-events: auto;
    width: 100%;
    height: 100%;
    // margin-top: 40vh;
    @include media("<=phone-plus") {
      width: 100%;
      height: 400px;
    }
  }
}
.dragHandle {
  cursor: grab;
}
.meeting-container-views-btns {
  cursor: grab;
  position: relative;
  padding: 2px 0;
  width: 100%;
  // height: 40px;
  display: flex;
  i {
    font-size: 1rem;
    margin-top: 0px;
    padding: 2px 4px;
    border-radius: 8px;
    background: #4444;
    color: #ddda;
    // box-shadow: 0px 0px 8px #444;
    &:active {
      transform: scale(0.85);
    }
  }
  // first child i
  i:nth-child(1) {
    margin-left: auto;
  }
}
.meeting-container-tools-btns {
  position: relative;
  padding: 2px 8px 6px;

  display: flex;
  justify-content: space-between;

  i {
    font-size: 1.1rem;
    margin-top: 0px;
    border-radius: 8px;
    background: #4444;
    color: #ddda;
    // box-shadow: 0px 0px 8px #444;
    &:active {
      transform: scale(0.85);
    }
  }
}
.network-widget-coverplate {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  background-image: url("https://aws-manhattan-bucket-01.s3.amazonaws.com/event/4358c130-d1b4-11ea-b523-b9262ae27927/60a509b96f670e3fbd83b4c60ce15060-hero.jpg");
  background-position: right;
  background-size: cover;
  background-attachment: fixed;
  z-index: 3000;
  display: flex;
  gap: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h2 {
    font-size: 2.3rem;
    font-weight: bold;
    max-width: 70%;
    text-align: center;
  }
  h3 {
    font-size: 1.3rem;
    font-weight: bold;
    max-width: 70%;
    text-align: center;
  }
}

.neon {
  color: #fff;
  text-shadow: 0 0 5px #333, 0 0 10px #333, 0 0 20px #333, 0 0 40px #f58adc,
    0 0 80px #f58adc, 0 0 90px #f58adc, 0 0 100px #f58adc, 0 0 150px #f58adc;
}
.lds-grid {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-grid div {
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  animation: lds-grid 1.2s linear infinite;
}
.lds-grid div:nth-child(1) {
  top: 8px;
  left: 8px;
  animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
  top: 8px;
  left: 32px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
  top: 8px;
  left: 56px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(4) {
  top: 32px;
  left: 8px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(5) {
  top: 32px;
  left: 32px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(6) {
  top: 32px;
  left: 56px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(7) {
  top: 56px;
  left: 8px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(8) {
  top: 56px;
  left: 32px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(9) {
  top: 56px;
  left: 56px;
  animation-delay: -1.6s;
}
@keyframes lds-grid {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>